import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { ONBOARDING_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseBulkDownloadPropertyProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const bulkDownloadProperty = async (communityId: string) =>
  await axiosAuth.get(`${ONBOARDING_API(communityId)}/properties/template/with-data`, {
    responseType: "blob",
  });

const useBulkDownloadProperty = ({
  communityId,
  queryParams
}: UseBulkDownloadPropertyProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["bulk-download-property", communityId],
    queryFn: () => bulkDownloadProperty(communityId),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useBulkDownloadProperty;
